import { Dialog, Transition } from '@headlessui/react';
import { FC, useEffect, useState } from 'react';
import IBookYourSeatsProps from './interface';
import { useForm } from 'react-hook-form';
import CertifyingAuthority from '../../../layout-a/forms/common/Inputs/CertifyingAuthority';
import FirstName from '../../../layout-a/forms/common/Inputs/FirstName';
import LastName from '../../../layout-a/forms/common/Inputs/LastName';
import Email from '../../../layout-a/forms/common/Inputs/Email';
import PhoneNumber from '../../../layout-a/forms/common/Inputs/PhoneNumber';
import tw, { styled } from 'twin.macro';
import Collapsible from 'react-collapsible';
import WhatsappUpdatesCheckbox from '../../../layout-a/forms/common/Inputs/WhatsappUpdatesCheckboxUpgrad';
import Course from '../../../layout-a/forms/common/Inputs/Course';
import NumberOfParticipants from '../../../layout-a/forms/common/Inputs/NumberOfParticipants';
import Company from '../../../layout-a/forms/common/Inputs/Company';
import { MinusIcon, PlusIcon, XIcon } from '@heroicons/react/solid';
import Message from '../../../layout-a/forms/common/Inputs/Message';
import BookyourSeatV2 from '../../../../public/website_next_images/masterclass/bookseatv2.png';
import Image from 'next/image';
import generateOTP from '../../../../lib/common/otpGenerator';
import MCSubmitHandler from '../../submitHandler';
import SuccessPopup from '../../SuccessPopup';
import SelectTag from '../../../layout-a/forms/common/Inputs/Select';
import TermsAndCondition from '../../../../components/layout-a/forms/common/Inputs/TermsAndConditionCheckboxUpgrad';
import Spinner from '../../../layout-a/components/common/Spinner';
import MasterClassContainer from '../../container';
import MobileVerificationPopUpV2 from '../MobileVerificationV2';
import { EventData } from '../../../../lib/events/constants';
import UpGradSubmitHandler from '../submitHandler';
import { IBookYourSeatFormProps } from '../BookYourSeat/interface';

const CloseButton = tw.button`
  border-transparent
  outline-none
  z-50
`;

const DialogContainer = tw.div`
fixed
inset-0
bg-black
bg-opacity-25
transition-opacity
`;

const ButtonContainer = tw.div`
absolute
top-0
right-0
pt-4
pr-4
`;

const Title = tw.div`
md:text-center
text-left
text-xl
sm:text-[32px]
sm:leading-[41px]
font-bold
leading-[26px]
sm:mb-4
mb-6
relative
`;

const ContentContainer = tw.div`
sm:flex 
sm:justify-center 
sm:items-center `;

const Content = tw.div`
  w-full sm:max-w-[447px] text-[#333333] font-regular text-sm leading-[21px] sm:text-base sm:leading-6 mb-10 md:text-center text-left
`;

const InfoContainer = tw.div`
md:py-[33px]
pt-4
pb-6
`;
const Container = tw.div`
    w-full  flex 
`;

const LeftContainer = tw.div`
  hidden md:flex md:w-[575px] bg-[#F8FAFE]  flex-col pl-[111px] pr-[83px] pt-10 pb-[33px]
`;

const RightContainer = tw.div`
  md:w-[631px] h-full px-4 pt-4 pb-10 md:pl-[71px] md:pr-[72px] md:pt-6 md:pb-6
`;

const TitleContainer = styled.h2(({ align }) => [
  tw`
    font-bold   text-black mb-3 md:mb-3  relative  text-left  md:text-center  text-xl leading-[26px] md:leading-[26px] md:text-[20px]
      `,
]);

const DescriptionContainer = tw.div`
   leading-[21px] text-sm    text-[#333333] md:mb-0 mb-[26px]
  `;

const Popup = tw.div`
relative
inline-block
bg-white
rounded-t-[3px] 
md:rounded-xl
text-left
overflow-hidden
shadow-xl
transform
transition-all
md:my-1
`;

const PopupContainer = tw.div`
flex
md:items-center
items-end
justify-center
min-h-screen
text-center
`;
const OtpContainer = tw.div`w-12 h-12`;

const VerifyButtonContainer = tw.div`
flex 
justify-center 
items-center 
`;

const VerifyButton = tw.button`
w-full 
sm:w-[164px]  
bg-[#db4144] 
text-white 
py-4 
text-center 
font-semibold 
md:font-bold 
md:text-xl 
md:leading-6 
text-sm 
leading-[19px] 
rounded-[3px] 
md:rounded`;

const ContactUsContent = tw.p` 
font-regular 
text-sm 
leading-[19px] 
text-[#666666]
text-center`;

const FormContainer = tw.form`
    leading-[22px] text-[#444] text-sm
`;

const data = [
  { keyPoints: 'Complete guidance and support throughout program' },
  { keyPoints: 'Real-time insight and industry-relevant projects' },
  { keyPoints: 'Highly experienced mentors and trainers for support' },
  { keyPoints: 'Hands-on projects and assignments for max retention' },
  { keyPoints: 'Shareable and highly credible Completion certificate' },
  { keyPoints: 'Loads of exciting prizes and scholarships to be win' },
];

const UgBookYourSeatPopUpV2 = ({
  title,
  description,
  setOpen,
  isOpen,
  isOTPVerified,
  sectionName,
  webinarDate,
  webinarEndDate,
  webinarId,
  zoomLink,
  instructor,
  classType,
  program,
}: IBookYourSeatFormProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitted },
    reset,
    setValue,
    getValues,
  } = useForm({
    mode: 'onTouched',
  });
  const inputProps = { register, errors, isSubmitted, setValue, getValues };

  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  //const [showBookYouSeatPopUp, setShowBookYouSeatPopUp] = useState(true);
  const [optionalOpen, setOptionalOpen] = useState<boolean>(false);
  const toggleOptional = () => setOptionalOpen(!optionalOpen);

  const [leadData, setLeadData] = useState(0);

  const [pageURL, setPageURL] = useState('');

  const [buttonStatus, setButtonStatus] = useState<boolean>(false);

  // close
  const close = () => {
    setOpen(false);
    setButtonStatus(false);
  };

  useEffect(() => {
    setPageURL(window.location.href);
  }, []);

  const onSubmit = async (data: any) => {
    setButtonStatus(true);
    const eName = EventData[sectionName.replace('click-register', 'submit')]?.name;
    const eLabel = EventData[sectionName.replace('click-register', 'submit')]?.label;
    const eAction = EventData[sectionName.replace('click-register', 'submit')]?.action;

    const extraData = {
      leadType: 'MASTER_CLASS_APPLY_NOW',
      static_lead_type: 'MASTER_CLASS_APPLY_NOW',
      page: `${pageURL}`,
      action: eAction,
      name: eName,
      label: eLabel,
      program: program,
    };

    const response = await UpGradSubmitHandler(data, extraData, reset);
    if (response) {
      setLeadData(response.response);
      setButtonStatus(false);
      setShowOtpPopup(true);
      setOpen(false);
    }
  };
  return (
    <>
      <div className="absolute">
        <Transition.Root show={isOpen}>
          <Dialog as="div" className="fixed inset-0 z-[200] overflow-y-auto" onClose={setOpen}>
            <MasterClassContainer>
              <PopupContainer className="flex md:items-center items-end justify-center text-center sm:block sm:p-0">
                <Transition.Child
                  enter="ease-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <Dialog.Overlay>
                    <DialogContainer />
                  </Dialog.Overlay>
                </Transition.Child>

                <Transition.Child
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Popup className={`md:w-[1206px] w-full  -mb-[6px] md:mb-0`}>
                    <ButtonContainer className="z-[250]">
                      <CloseButton type="button" onClick={close}>
                        <XIcon className="w-5 hover:text-[#585858]" />
                      </CloseButton>
                    </ButtonContainer>
                    <Container>
                      <LeftContainer>
                        <div className="relative text-center mb-10">
                          <img
                            src={'https://d2o2utebsixu4k.cloudfront.net/master-class/bookseatv2.png'}
                            width="381"
                            height="320"
                          />
                        </div>
                        <div className="text-black text-2xl font-bold leading-[31px] mb-4">Book Your Seat To Get</div>
                        <div className=" text-[14px] text-[#333333] leading-[21px]">
                          {data.map((ele, index) => {
                            return (
                              <div className="flex gap-x-1 mb-2 items-center" key={index}>
                                <div className="w-[10px] h-[10px]">
                                  <img
                                    src="https://d2o2utebsixu4k.cloudfront.net/master-class/arrow-right.png"
                                    width="10"
                                    height="10"
                                  />
                                </div>
                                <div className=" flex-1 h-[21px]  w-full overflow-hidden" key={index}>
                                  {ele.keyPoints}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </LeftContainer>

                      <RightContainer>
                        <TitleContainer className="text-left md:text-center">{title}</TitleContainer>
                        {description && (
                          <DescriptionContainer className="text-left md:text-center">
                            <div dangerouslySetInnerHTML={{ __html: description }}></div>
                          </DescriptionContainer>
                        )}
                        <div className="border-t border-black/10 hidden md:block mt-5 mb-[22px]"></div>
                        <FormContainer onSubmit={handleSubmit(onSubmit)}>
                          <div className="grid grid-cols-2 md:gap-x-5 md:items-center">
                            {/* Certifying authority */}
                            <CertifyingAuthority {...inputProps} />

                            {/* First name */}
                            <FirstName {...inputProps} fullWidth={true} asterisk={true} />

                            {/* Last name */}
                            <LastName {...inputProps} fullWidth={true} asterisk={true} />
                          </div>

                          <div className="grid md:grid-cols-2 gap-x-5 md:items-center">
                            {/* phone number */}
                            <PhoneNumber {...inputProps} fullWidth={true} asterisk={true} />

                            <SelectTag {...inputProps} />
                          </div>

                          {/* Email */}
                          <div className="grid md:grid-cols-1 gap-x-5 md:items-center">
                            <Email {...inputProps} asterisk={true} fullWidth={true} />
                          </div>

                          {/* Optional */}
                          <div
                            className="w-full flex items-center justify-between mb-5 cursor-pointer"
                            onClick={toggleOptional}
                          >
                            <div className="text-sm text-[#333333] font-regular leading-[18px] md:leading-4">
                              Have a doubt? (optional)
                            </div>
                            <div>
                              {optionalOpen ? (
                                <MinusIcon className="w-4 text-[#231f20]" />
                              ) : (
                                <PlusIcon className="w-4 text-black" />
                              )}
                            </div>
                          </div>

                          <Collapsible open={optionalOpen} trigger="" overflowWhenOpen="visible">
                            <div>
                              <div className="relative md:mb-8 mb-[25px] w-full group">
                                <Message {...inputProps} />
                              </div>
                            </div>
                          </Collapsible>

                          <WhatsappUpdatesCheckbox register={register} isWhatsappContent={true} />

                          <TermsAndCondition
                            errors={errors}
                            isSubmitted={isSubmitted}
                            register={register}
                            isWhatsappContent={true}
                          />

                          <VerifyButtonContainer>
                            <button className="mt-[21px] flex justify-center items-center px-8 bg-[#db4144] text-white font-bold py-4 text-center md:text-base md:leading-[19px] text-sm leading-[19px] rounded-[3px] md:rounded">
                              {buttonStatus && <Spinner />}
                              {buttonStatus ? <span className="pl-[2px]">Submitting...</span> : 'Submit'}
                            </button>
                          </VerifyButtonContainer>

                          <ContactUsContent className="mt-[30px]">
                            Have any further questions ? &nbsp;
                            <a
                              className="font-semibold text-black underline"
                              target={'_blank'}
                              href="mailto:bootcampsupport@upgrad.com"
                              rel="noreferrer noopener"
                            >
                              Contact Us
                            </a>
                          </ContactUsContent>
                        </FormContainer>
                      </RightContainer>
                    </Container>
                  </Popup>
                </Transition.Child>
              </PopupContainer>
            </MasterClassContainer>
          </Dialog>
        </Transition.Root>
      </div>

      {showOtpPopup && (
        <MobileVerificationPopUpV2
          title={'You are almost there!'}
          isOpen={showOtpPopup}
          setOpen={setShowOtpPopup}
          leadData={leadData}
          sectionName={sectionName}
          setShowSuccessPopup={setShowSuccessPopup}
          setShowBookYouSeatPopUp={setOpen}
          webinarDate={webinarDate}
          webinarEndDate={webinarEndDate}
          webinarId={webinarId}
          zoomLink={zoomLink}
          instructor={instructor}
          classType={classType}
          setLeadData={setLeadData}
        />
      )}

      {showSuccessPopup && (
        <SuccessPopup
          contentSelected={true}
          isOpen={showSuccessPopup}
          setOpen={setShowSuccessPopup}
          sectionName={sectionName}
        />
      )}
    </>
  );
};

export default UgBookYourSeatPopUpV2;
